import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import logo from "../assets/logo.jpg"; // local logo

export default function VerifyAccount() {
  const navigate = useNavigate();
  const { uidb64, token } = useParams(); // MUST match route placeholders
  const [status, setStatus] = useState("Verifying...");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        const res = await api.get(`/accounts/verify-email/${uidb64}/${token}/`);
        setStatus(res.data.detail || "Email verified successfully.");
        setSuccess(true);

        // Redirect after 2 seconds
        setTimeout(() => navigate("/login"), 2000);
      } catch (err) {
        console.error("Verification error:", err);
        setStatus(err.response?.data?.detail || "Verification failed.");
        setSuccess(false);
      }
    };

    // Only call if both uidb64 and token exist
    if (uidb64 && token) {
      verifyAccount();
    } else {
      setStatus("Invalid verification link.");
    }
  }, [uidb64, token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={logo} alt="Labor Prophet Logo" className="h-20 w-auto" />
        </div>

        <h2 className="text-2xl font-bold mb-4">Account Verification</h2>
        <p
          className={`mb-4 font-medium ${
            success ? "text-green-600" : "text-red-600"
          }`}
        >
          {status}
        </p>

        {/* Optional button for immediate login */}
        <button
          onClick={() => navigate("/login")}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-colors"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}
